module.exports = __webpack_public_path__ + "img/scan_second.9b227885.png";